module.exports = __webpack_public_path__ + "img/ssb_simple_logo.99a138c7.png";